/* Remove product collapsible rows if empty */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product__accordion').forEach(accordion => {
    const content = accordion.querySelector('.accordion__content');
    if (content && content.textContent.trim() === '') {
      accordion.remove();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".grid__item > .accordion");
  let visibleCount = 0;
  accordions.forEach(function (accordion) {
    const title = accordion.querySelector(".accordion__title");
    if (!title || !title.textContent.trim()) {
      accordion.style.display = "none";
    } else {
      visibleCount++;
    }
  });
  if (visibleCount === 0) {
    const section = document.querySelector(".collapsible-content");
    if (section) {
      section.remove();
    }
  }
});

/* Remove product table heading if no table */
(() => {
  const allowedTitles = ['daugiau informacijos', 'more information'];

  function hideIfEmpty() {
    const productTableWrap = document.querySelector('.product-table');
    const hasRealTable =
      productTableWrap &&
      productTableWrap.querySelector('table') &&
      productTableWrap.querySelector('tbody tr');

    if (hasRealTable) return;

    document.querySelectorAll('.rich-text__heading').forEach(heading => {
      const text = heading.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (allowedTitles.includes(text)) {
        const section = heading.closest('.shopify-section');
        if (section) section.style.display = 'none';
      }
    });

    if (productTableWrap) {
      const tableSection = productTableWrap.closest('.shopify-section');
      if (tableSection) tableSection.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', hideIfEmpty);
})();

/* Sticky add to cart */
document.addEventListener("DOMContentLoaded", () => {
  const stickyBar = document.getElementById("sticky-add-to-cart");
  const stickyForm = stickyBar.querySelector("form.sticky-cart__form");

  const stickyQtyInput = stickyBar.querySelector('quantity-input.quantity.sticky-qty input.quantity__input');
  const mainQtyInput = document.querySelector('quantity-input.quantity:not(.sticky-qty) input.quantity__input');

  if (stickyQtyInput && mainQtyInput) {
    const sync = (from, to) => {
      if (to.value !== from.value) {
        to.value = from.value;
        to.dispatchEvent(new Event("change", { bubbles: true }));
      }
    };

    mainQtyInput.addEventListener("input", () => sync(mainQtyInput, stickyQtyInput));
    stickyQtyInput.addEventListener("input", () => sync(stickyQtyInput, mainQtyInput));
  }

  const mainVariantSelects = document.querySelectorAll('form [name^="options"]');
  const variantIdInput = stickyForm.querySelector(".variant-id");

  if (mainVariantSelects.length && Shopify.product.variants) {
    const updateVariant = () => {
      const selectedOptions = Array.from(mainVariantSelects).map(s => s.value);
      const match = Shopify.product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      if (match) variantIdInput.value = match.id;
    };

    mainVariantSelects.forEach(select => select.addEventListener("change", updateVariant));
    updateVariant();
  }
});

/* Video autoplay */
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".deferred-media__poster");
  if(!buttons) return;
  buttons.forEach(btn => {
    setTimeout(() => {
      btn.click();
    }, 500);
  });
});